module.exports = __webpack_public_path__ + "1a54b2338d6bfcf66d43cc9931965e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/addIcon.png
// module id = 63
// module chunks = 0